import React, { createContext, useContext, useEffect, useState } from "react";
import { authApi, getToken, getStoredAdmin, setSession, clearSession } from "./adminApi";
const AuthContext = createContext(null);
export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(getStoredAdmin());
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let cancelled = false;
    async function verify() {
      const token = getToken();
      if (!token) {
        setLoading(false);
        return;
      }
      try {
        const me = await authApi.me();
        if (!cancelled) setAdmin(me);
      } catch {
        clearSession();
        if (!cancelled) setAdmin(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    verify();
    return () => {
      cancelled = true;
    };
  }, []);
  async function login(email, password) {
    const data = await authApi.login(email, password);
    setSession(data.token, data.admin);
    setAdmin(data.admin);
    return data.admin;
  }
  function logout() {
    clearSession();
    setAdmin(null);
  }
  return (
    <AuthContext.Provider value={{ admin, loading, login, logout, isAuthenticated: !!admin }}>
      {children}
    </AuthContext.Provider>
  );
}
export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside <AuthProvider>");
  return ctx;
}